import { ref, onChildAdded, onChildChanged, off } from "firebase/database";
import store from "store";
import { database } from "../../../services/firebaseService/firebaseConfig";
import { getEventPrefix } from "../firebase";
import { addUsersInEvent, isUsersInEventLoaded } from "./actions";
import { USER_PATH } from "../../../services/firebaseService/storagePaths";

export const getUsersInEvent = (eventId: string) => {
  if (!eventId) {
    return;
  }

  const usersRef = ref(
    database,
    `${getEventPrefix()}/${eventId}/${USER_PATH}/`,
  );

  off(usersRef);

  // Get only newly added user after getting once
  onChildAdded(usersRef, (newUserSnapshot) => {
    if (!newUserSnapshot.key) return;

    store.dispatch(addUsersInEvent(newUserSnapshot.key, newUserSnapshot.val()));
  });

  onChildChanged(usersRef, (updatedUserSnapshot) => {
    if (!updatedUserSnapshot.key) return;

    const updatedUser = updatedUserSnapshot.val();
    store.dispatch(addUsersInEvent(updatedUserSnapshot.key, updatedUser));
  });
  store.dispatch(isUsersInEventLoaded(true, eventId));
};
